/***
*
*   CAMPAIGN
*   Information for user to get help and support
*
**********/

import React, { Fragment, useState, useEffect } from 'react';
import { Table, useAPI } from 'components/lib';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { ListContents } from './listContents';
import Style from './listLeads.module.scss';

const limit = 10;

export function Leads(props){

  //state
  const [leadList, setLeadList] = useState([]);
  const [leadListUpdated, setLeadListUpdated] = useState([]);
  const [pages, setPages] = useState(0);
  const [name, setName] = useState('');
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [selectedPage, setSelectedPage] = useState(0);
  const [selectedList, setSelectedList] = useState(null);

  const importList = async event => {
    event.preventDefault();
    const form = event.currentTarget;
    setError('');
    setMessage('');
    if (!file || !/\.(xlsx|xls|csv)$/i.test(file.name) || file.size > 5 * 1024 * 1024) {
      setError('Selecciona un Excel o CSV de hasta 5 MB.');
      return;
    }
    setUploading(true);
    try {
      const data = new FormData();
      data.append('name', name.trim());
      data.append('file', file);
      const response = await axios.post('/api/user/list-leads/import', data);
      const updated = [response.data.data, ...leadListUpdated];
      setLeadListUpdated(updated);
      setLeadList(updated.slice(0, limit));
      setSelectedPage(0);
      setPages(1);
      setMessage(response.data.message);
      setName('');
      setFile(null);
      form.reset();
    } catch (err) {
      setError(err.response?.data?.message || 'No se pudo importar la lista. Inténtalo de nuevo.');
    } finally { setUploading(false); }
  };

  const listLeads = useAPI('/api/user/list-leads');

  useEffect(() => {
    if(listLeads.data && leadList.length === 0 && pages === 0) {
      let offset = Math.ceil(limit);
      let values = listLeads.data.slice(0, offset);
      setLeadList(values);
      setPages(1);
      setLeadListUpdated(listLeads.data);
    }
  }, [listLeads, leadList, pages]);

  const handlePageClick = (data) => {
    let selected = data.selected;
    setSelectedPage(selected);
    let offset = Math.ceil((selected + 1) * limit);
    let values = offset < leadListUpdated.length ? leadListUpdated.slice(offset - (limit), offset) : leadListUpdated.slice(offset - (limit), leadListUpdated.length);
    setLeadList(values);
  };

  let pagesList = leadListUpdated?.length > 0 ? Math.ceil(leadListUpdated.length / limit) : 0;

  if (selectedList) return <ListContents list={selectedList} onBack={() => setSelectedList(null)} />;

  return (
    <Fragment>

      <form className={Style.importForm} onSubmit={importList} style={{ marginTop: '2em', padding: '1.5em', background: 'var(--df-surface)', borderRadius: 8 }}>
        <h2>Importar lista de leads</h2>
        <p>Sube un Excel (.xlsx, .xls) o CSV. Se importa la primera hoja, con encabezados en la primera fila. Máximo: 5 MB y 10.000 leads.</p>
        <p>Columna obligatoria: email. Opcionales: first_name (First Name), last_name (Last Name), empresa (Company), contacto, cliente_id, url_linkedin. Cada fila debe tener un correo válido y único. También se acepta nombre para archivos anteriores. Las columnas adicionales no se importan.</p>
        <p><a href="/templates/lista-leads.csv" download>Descargar plantilla CSV</a></p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1em', alignItems: 'end' }}>
          <label>Nombre de la lista
            <input aria-label="Nombre de la lista" type="text" required maxLength={120} value={name} onChange={event => setName(event.target.value)} disabled={uploading} />
          </label>
          <label>Archivo Excel o CSV
            <input aria-label="Archivo Excel o CSV" type="file" accept=".xlsx,.xls,.csv" required onChange={event => setFile(event.target.files[0] || null)} disabled={uploading} />
          </label>
          <button className={Style.createList} type="submit" disabled={uploading || listLeads.loading || !name.trim() || !file} aria-busy={uploading}>{uploading ? 'Importando…' : 'Crear lista'}</button>
        </div>
        {error && <p role="alert" style={{ color: 'var(--df-error)' }}>{error}</p>}
        {message && <p role="status" style={{ color: 'var(--df-success)' }}>{message}</p>}
      </form>
      <div style={{ marginTop: '3em' }}>
        {pagesList !== 0 &&
          <div 
              style={{
                  width: '100%', 
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  marginBottom: '1em'
              }}
          >
            <ReactPaginate
                previousLabel={'Anterior'}
                nextLabel={'Siguiente'}
                breakLabel={'...'}
                onPageChange={handlePageClick}
                pageCount={pagesList}
                forcePage={selectedPage}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                containerClassName={'pagination'}
                activeClassName={'page-active'}
                breakClassName={'break'}
                breakLinkClassName={'dots'}
                pageLinkClassName={'number'}
                pageClassName={'page-number'}
                nextClassName='next-page'
                nextLinkClassName='next-page'
                previousClassName='previous-page'
                previousLinkClassName='previous-page'
            />
          </div>
        }
        <Table
          onRowClick={setSelectedList}
          search
          data={ leadList ? leadList : [] }
          hide={['_id', '__v', 'user_id', 'id', 'list', 'check', 'account']}
          loading={ listLeads && listLeads.data ? false : true }
        />
      </div>

      
    </Fragment>
  )
}
